<template>
  <auth-layout pageClass="login-page">
    <div class="row d-flex justify-content-center align-items-center">
      <div class="col-lg-4 col-md-6 col-sm-8">
        <form @submit.prevent="submit">
          <!-- <fade-render-transition> -->
            <card>
              <l-alert type="danger" v-show="errorMessage">
                <span>{{ errorMessage }}</span>
              </l-alert>
              <div slot="header">
                <div class="text-center logo-wrapper">
                  <img :src="'/static/img/' + style + '_logo.png'" class="wamed-logo" >
                </div>
                <h3 class="card-title text-center">Account aktivieren</h3>
              </div>
              <div>
                <fg-input label="Passwort"
                  type="password"
                  v-model="password"
                ></fg-input>

                <fg-input label="Passwort bestätigen"
                  type="password"
                  v-model="password_confirmation"
                ></fg-input>
              </div>
              <div class="text-center">
                <button type="submit" class="btn btn-primary btn-fill btn-round btn-wd"
                  :disabled="! canSubmit"
                >
                  Account erstellen
                </button>
              </div>
            </card>
          <!-- </fade-render-transition> -->
        </form>
      </div>
    </div>
  </auth-layout>
</template>
<script>
import AuthLayout from './AuthLayout.vue'
import LAlert from 'src/components/Alert'

export default {
  components: {
    AuthLayout,
    LAlert
  },
  data () {
    return {
      token: this.$route.params.token,
      password: '',
      password_confirmation: '',
      errorMessage: '',
      style:  process.env.VUE_APP_STYLE ? process.env.VUE_APP_STYLE : 'ederit'
    }
  },
  methods: {
    submit () {
      this.errorMessage = ''

      const { token, password } = this
      this.$store.dispatch('activateUser', {
        token,
        password,
        password_confirmation: this.password_confirmation
      }).then(() => {
        this.$notify({
          message: 'Aktivierung abgeschlossen.',
          type: 'success'
        })
        this.$router.push('/')
      }).catch(({ response }) => {
        const key = Object.keys(response.data.errors)[0]
        this.errorMessage = response.data.errors[key][0]
      })
    }
  },
  computed: {
    canSubmit () {
      return this.password.trim() && this.password_confirmation.trim()
    }
  }
}
</script>
<style>
  .navbar-nav .nav-item p{
    line-height: inherit;
    margin-left: 5px;
  }
</style>
